module.exports = __webpack_public_path__ + "img/bg3.1f92e6ef.jpg";